module.exports = __webpack_public_path__ + "static/img/yiqingtang.96378da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/yiqingtang.png
// module id = eKd4
// module chunks = 0